import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { InlineFieldLayout, Label } from '@clds/form';
import { RadioGroup } from '@clds/radio';

export const SectionBox = styled.section`
  padding: ${(props) => props.theme.spacing.xs};
  border-bottom: 1px solid ${(props) => props.theme.palette.secondary};
  position: relative;
  > label {
    font-weight: bold;
    white-space: nowrap;
    display: block;
    padding-bottom: ${(props) => props.theme.spacing.xs};
  }
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
`;

export const LastSectionBox = styled(SectionBox)`
  border-bottom: 0px none;
`;

export const InlineFieldLayoutCustomized = styled(InlineFieldLayout)`
  padding-bottom: ${(props) => props.theme.spacing.xs};
`;

export const RadioLabel = styled(Label)`
  padding-top: 1px; // aligment fix
  font-size: ${({ theme }) => theme.font.size.xxs};
`;

export const Radio = styled(RadioGroup.Radio)`
  width: 1rem;
  height: 1rem;
  &,
  &:hover,
  &:checked,
  &[disabled] {
    &::before {
      background-color: ${({ theme }) => theme.palette.surface};
    }
  }
`;
